import { AxiosRequestConfig } from 'axios';
import { HttpResponse, ajax } from '../../../../common/ajax';
import { config } from '../../config';
import { ProductListModel } from '../../models/Product';

interface IWishlistService {
  getProducts: (
    config?: AxiosRequestConfig,
  ) => Promise<HttpResponse<ProductListModel[]>>;
  removeProduct: (
    productId: number,
    config?: AxiosRequestConfig,
  ) => Promise<HttpResponse<any>>;
  addProduct: (
    productId: number,
    config?: AxiosRequestConfig,
  ) => Promise<HttpResponse<any>>;
}

export const wishlistService: IWishlistService = {
  getProducts(axiosConfig) {
    return ajax.get<ProductListModel[]>(
      `${config.benefitApiUrl}/wishlist`,
      axiosConfig,
    );
  },
  removeProduct(productId, axiosConfig) {
    return ajax.delete(
      `${config.benefitApiUrl}/wishlist/${productId}`,
      axiosConfig,
    );
  },
  addProduct(productId, axiosConfig) {
    return ajax.post(
      `${config.benefitApiUrl}/wishlist`,
      { productId },
      axiosConfig,
    );
  },
};
